import { Component, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MasterDataService } from '../../services/master-data.service';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { BranchFilterService } from 'src/app/services/branch-filter.service';

@Component({
  selector: 'app-latest-ctc-details-report',
  templateUrl: './latest-ctc-details-report.component.html',
  styleUrls: ['./latest-ctc-details-report.component.css']
})
export class LatestCtcDetailsReportComponent implements OnInit {

  selectedBranch;
  branchList;
  partnerList;
  selectedPartner;
  isBranchSelected = false;
  isPartnerSelected = false;
  latestCtcDetailsReport;
  showExportToExcelButton: Boolean;
  userRole;
  accessResponse: any;

  constructor(private masterDataService: MasterDataService,
    private commonMessageService: CommonMessageService, private branchFilterService: BranchFilterService) { }

  ngOnInit(): void {
    this.loadInitialDetails();
  }

  loadInitialDetails() {
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });
  }

  selectAllBranch(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected, false);
    this.isBranchSelected = !this.isBranchSelected;
    this.getPartnerByBranch();
  }

  selectAllPartner(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected, false);
    this.isBranchSelected = !this.isBranchSelected;
  }
  selectAll(select: NgModel, values, isSelected, isId) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  getPartnerByBranch() {
    this.partnerList = [];
    var branchId = this.selectedBranch.map(({ id }) => id);
    if (branchId.length > 0) {
      this.masterDataService.getPartnersByBranch(branchId).subscribe((res: any) => {
        console.log('partner list', res);
        this.partnerList = res;
      });
    }
  }

  onViewReport() {
    if (this.selectedBranch == null ||
      this.selectedBranch.length === 0 ||
      this.selectedPartner == null ||
      this.selectedPartner.length === 0
    ) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please choose all the values');
      return;
    }
    const branchIds = this.selectedBranch.map(branch => branch.id).join(',');
    const partnerIds = this.selectedPartner.map(partner => partner.id).join(',');

    this.masterDataService.getLatestCtcDetailsReport(branchIds, partnerIds).subscribe((res: any) => {
      console.log('latest CTC details report', res);
      this.latestCtcDetailsReport = res;

      if (this.latestCtcDetailsReport == null) {
        this.commonMessageService.swalAlertWithoutIcon('', "No Record Found.");
        this.showExportToExcelButton = false;
      } else {
        this.showExportToExcelButton = true;
      }
    });
  }

  excelExportCtcDetailsReport() {
      const branchIds = this.selectedBranch.map(branch => branch.id).join(',');
    const partnerIds = this.selectedPartner.map(partner => partner.id).join(',');
    this.masterDataService.getLatestCtcDetailsReportExcel(branchIds, partnerIds).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "Latest Ctc Details Report.xlsx";
      link.click();
    });
  }
}
